export default __webpack_public_path__ + "static/media/e.e5e79dda.wav";